import {
  type TemplatedConfigurationInputCustomAttributeConfigurationType,
  type TemplatedConfigurationInputType,
  type TemplatedConfigurationType,
} from "../schemas/TemplatedConfigurationSchemas.ts";
import type { TemplatedConfigurationFilterType } from "../schemas/TemplatedConfigurationSchemas.ts";
import { fetchAndCollate, getFilterObject } from "../util/index.ts";
import type {
  GetListResponseType,
  GetOneRequestType,
  GetOneResponseType,
  ResourceAdapterType,
  GetListRequestType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

interface TemplatedConfigurationServiceType
  extends Pick<
    ResourceAdapterType<TemplatedConfigurationType>,
    "getList" | "getOne"
  > {
  getOne: (
    params: GetOneRequestType
  ) => Promise<GetOneResponseType<TemplatedConfigurationType>>;
  getList: (
    params: GetListRequestType<TemplatedConfigurationFilterType>
  ) => Promise<GetListResponseType<TemplatedConfigurationType>>;
  inputSchema: {
    getOne: (
      params: GetOneRequestType<{
        custom_attribute_configuration?: TemplatedConfigurationInputCustomAttributeConfigurationType;
      }>
    ) => Promise<GetOneResponseType<TemplatedConfigurationInputType>>;
  };
}

export const TemplatedConfigurationAdapter: TemplatedConfigurationServiceType =
  {
    getOne: ({ id }) =>
      restAPI.nodeAPI
        .GET<TemplatedConfigurationType>({
          endpoint: `/templated_configurations/${id}`,
        })
        .then((resp) => ({
          data: resp,
        })),

    getList: ({ filters, page, pageSize, sortBy, sortDirection }) =>
      fetchAndCollate(
        ({ page, pageSize }) =>
          restAPI.nodeAPI.POST({
            endpoint: "/templated_configurations/search_company",
            body: {
              page,
              page_size: pageSize,
              sort_by: sortBy,
              sort_direction: sortDirection,
              filter: getFilterObject(filters),
            },
          }),
        page,
        pageSize
      ),

    inputSchema: {
      getOne: ({ id, meta }) =>
        restAPI.nodeAPI
          .POST<TemplatedConfigurationInputType>({
            endpoint: `/templated_configurations/${id}/input_schema`,
            body: meta,
          })
          .then((resp) => ({ data: resp })),
    },
  };
